/* eslint camelcase:0 */
import pick from 'lodash/pick';
import find from 'lodash/find';
import concat from 'lodash/concat';
import take from 'lodash/take';

const fields = [
  'dhd',
  'dho',
  'from_name',
  'from_city',
  'from_country',
  'from_st',
  'from_state',
  'to_name',
  'to_city',
  'to_country',
  'to_st',
  'to_state',
  'equipment',
  'to_lat',
  'to_lng',
  'from_lat',
  'from_lng',
];

const hash = ({from_name, to_name, equipment, dho, dhd}) =>
  [from_name, to_name, equipment, dho, dhd].join();

const query2recent = (query) => ({...pick(query, fields), id: hash(query)});

const update = (items, candidate) => {
  const filterFunc = i => i.id === candidate.id;

  if (find(items, filterFunc)) {
    return concat(candidate, items.filter((item) => !filterFunc(item)));
  }

  return concat(candidate, take(items, 4));
};

export {
  update,
  query2recent,
};



// WEBPACK FOOTER //
// ./src/modules/recentSearches/utils.js